import { Model } from './model';

export class PlatformDomain extends Model {
  logoUrl: string;
  logoMobileUrl: string;
  faviconUrl: string;
  canResetPassword: boolean;
  canRegister: boolean;
  canViewSettings: boolean;
  pagesLinkPlaceholder: string;
  richUrlPlaceholder: string;
  smsStopPlaceholder: string;
  showConcatenatedFlag: boolean;
  sendingPeriods: SendingPeriods[];
}

export class SendingPeriods extends Model {
  idPeriod: number;
  descriptionLabel: string;
  dayFrequency: number;
  monthFrequency: number;
  yearFrequency: number;
}
